import styled from 'styled-components';
import { rem } from 'polished';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
// import OutSideAlterer from '../OutsideAlerter';
import Search from '../AlgoliaSearch';
// import { __ } from '../../Utils';
import OutSideAlterer from '../OutSideAlterer';

const TEXT = [
  'OPTIVA 5 MATT ',
  'FEELINGS INTERIOR PAINT ',
  'ELITE FLAT BRUSH ',
  'HELMI 30 ',
];

const SearchMock = ({ fixedWidth, onHitClick, onSubmit }) => {
  const [showSearch, setShowSearch] = useState(false);
  const [placeholder, setPlaceholder] = useState('');

  const toggleSearch = () => {
    setShowSearch(!showSearch);
  };

  useEffect(() => {
    getAutoTyperText(0);
  }, []);

  const getAutoTyperText = (position = 0, goingBack = false, wordIndex = 0) => {
    if (!TEXT[wordIndex]) {
      getAutoTyperText(0);
      return;
    }
    const splited = TEXT[wordIndex].split('');

    if (splited[position + 1] && !goingBack) {
      setTimeout(() => {
        setPlaceholder(splited.slice(0, position).join(''));
        getAutoTyperText(position + 1, goingBack, wordIndex);
      }, 200);
    } else {
      setTimeout(
        () => {
          setPlaceholder(splited.slice(0, position).join(''));
          getAutoTyperText(
            position - 1,
            position > 1,
            position === 1 ? wordIndex + 1 : wordIndex,
          );
        },
        position === splited.length - 2 ? 1000 : 100,
      );
    }
  };

  return (
    <OutSideAlterer
      style={{ display: 'flex', width: '100%' }}
      onClick={() => {
        setShowSearch(false);
      }}
    >
      <Wrapper>
        <HeaderSearchWrapper>
          <SearchBoxWrapper
            onClick={() => toggleSearch()}
            fixedWidth={fixedWidth}
          >
            {/* <FontAwesomeIcon
              className="ais-SearchBox-submit"
              size="md"
              icon={['fas', 'search']}
            /> */}
            <input
              id="mockInput"
              className="ais-SearchBox-input"
              placeholder={`${'Čo hľadáte? Napr. farba na stenu: '} ${placeholder}`}
              value=""
            />
          </SearchBoxWrapper>
          <Search
            show={showSearch}
            toggleSearch={toggleSearch}
            onSubmit={q => onSubmit(q)}
            onHitClick={id => {
              onHitClick(id);
              setShowSearch(false);
            }}
          />
        </HeaderSearchWrapper>
      </Wrapper>
    </OutSideAlterer>
  );
};

export default SearchMock;

const Wrapper = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  padding: 0 ${rem(24)};
`;

const HeaderSearchWrapper = styled.div`
  display: flex;
  position: relative;
  height: 100%;
  width: 600px;
`;

const SearchBoxWrapper = styled.div`
  display: none;
  align-items: center;
  justify-content: center;
  height: 100%;

  @media (min-width: ${rem(700)}) {
    display: flex;
    width: 100%;
  }

  .ais-SearchBox-input {
    position: relative;
    width: 600px;

    height: ${rem(48)};
    padding-left: ${rem(80)};
    z-index: 10;
    border: ${rem(1)} solid #dedfe0;
    border-radius: ${rem(24)};

    /* background-color: yellow; */
    :focus {
      outline: none;
    }
  }

  .ais-SearchBox-submit {
    cursor: default;
    z-index: 11;
    position: absolute;
    /* top: 37%; */
    left: ${rem(32)};
  }
`;

SearchMock.defaultProps = {
  fixedWidth: false,
};

SearchMock.propTypes = {
  fixedWidth: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/Components/MockSearch/index.js